import { render, staticRenderFns } from "./detail-video.vue?vue&type=template&id=e68b84a2&"
import script from "./detail-video.vue?vue&type=script&lang=js&"
export * from "./detail-video.vue?vue&type=script&lang=js&"
import style0 from "./detail-video.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports